import Service from "../../../Services/index";
import moment from "moment";
const driverDetails = {
    namespaced: true,
    state: {
        filter_invoice : [],
        invoices : [],
        form :{
            invoices : [],
            invoice_other_fee : "",
            bonus:"",
            insurance_fee:"",
            roof_top : '',
            car_fee :"",
            deposit : "",
            damages_fee : "",
            driver_id : "",
            date : "",
            time_leave : "",
            date_time : '',
            transport_fee_total : 0,
            tax : "",
            is_tax : false,
        },
        driver_details_table : [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        SET_DRIVER_BONUS_LIST: (state, res) => {
            state.filter_invoice = res;
        },
        SET_FORM :(state,res)=>{
            const time = moment();
            const date = moment().format("YYYY-MM-DD");
            state.form.date = date;
            if(res.date){
                state.form.date = res.date;
            }
            state.form.time_leave = time;
            state.form.invoice_other_fee = res.invoice_other_fee;
            state.form.bonus = res.bonus;
            state.form.insurance_fee = res.insurance_fee;
            state.form.car_fee = res.car_fee;
            state.form.deposit = res.deposit;
            state.form.date_time = res.date_time
        },
        CLEAR_FORM : state=>{
            const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
            state.form = {
                invoices : [],
                invoice_other_fee : "",
                bonus:"",
                insurance_fee:"",
                car_fee :"",
                roof_top : '',
                deposit : "",
                damages_fee : "",
                driver_id : "",
                date : "",
                time_leave : "",
                date_time : currentTime,
                transport_fee_total : 0,
                tax : "",
                is_tax : false,
            }
        },
        SET_FORM_DRIVER_DETAILS:(state,res)=>{
            state.form = res;
        },
        SET_INVOICES : (state,invoice)=>{
            state.invoices = invoice;
        },
        SET_DRIVER_DETAILS_TABLE:(state,res)=>{
            state.driver_details_table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        CLEAR_DETAILS:(state,res)=>{
            state.driver_details_table = [];
            state.dataPaginate = {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            }
        }
    },
    actions: {
        setFilterInvoice({ commit },{id,date}) {
            return Service.DriverDetails.getFilterInvoice(id,date)
                .then(data => {
                    commit("SET_DRIVER_BONUS_LIST", data);
                    return data;
                });
        },
        showDriverDetailsId({commit},data){
            return Service.DriverDetails.showDriverDetailsByDriverId(data.driver_id,data.page).then(res=>{
                commit('SET_DRIVER_DETAILS_TABLE',res)
            });
        },
        save({commit},form){
            return Service.DriverDetails.saveDriverDetails(form);
        },
        driverShippingMonth({commit},{driver_id,date,transportation_id,transport_fee}){
            return Service.DriverDetails.driverShippingMonth(driver_id,date,transportation_id,transport_fee).then(data=>{
                commit("SET_FORM",data);
            });
        },
        clearForm({commit}){
            commit("CLEAR_FORM");
        },
        clearDetails({commit}){
            commit("CLEAR_DETAILS");
        },
        showDriverDetails({commit},{id}){
            return Service.DriverDetails.showDriverDetailsById(id).then(res=>{
                commit('SET_FORM_DRIVER_DETAILS',res);
            });
        },
        getInvoiceFromDriver({commit},{driver_id}) {
            return Service.DriverDetails.getInvoiceFromDriver(driver_id).then(res=>{
                commit('SET_INVOICES',res);
            });
        },
        updateDriverDetails({commit},data){
            return Service.DriverDetails.updateDriverDetails(data);
        },
        deleteDriverDetails({commit},id){
            return Service.DriverDetails.deleteDriverDetails(id);
        },
        deleteDriverTransport({commit},id){
            return Service.DriverDetails.deleteDriverTransport(id);
        },
        getCarFeeDriver({commit},data){
            return Service.DriverDetails.getCarFeeDriver(data).then(res=>{
                commit('SET_DRIVER_DETAILS_TABLE',res);
            });
        },
        //รายงานค่าเที่ยว
        getDriverTransportReport({commit},data){
            return Service.DriverDetails.getDriverTransportReport(data);
        },
        showDriverTransportReport({commit},id){
            return Service.DriverDetails.showDriverTransportReport(id);
        },
        editDriverTransportReport({commit},{id,data}){

        },
        getBalanceDriverTransport({commit}){
            return Service.DriverDetails.getBalanceDriverTransport();
        },
        saveDriverTransportReport({commit}, {id,data}){
            if(id){
                return Service.DriverDetails.editDriverTransportReport(id,data);
            }else{
                return Service.DriverDetails.createDriverTransportReport(data);
            }
        }
    }
};
export default driverDetails;
